(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4511],{

/***/ 14703:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/news/news_detail/[newsId]",
      function () {
        return __webpack_require__(93154);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81683);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_pagelay__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41520);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74855);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49667);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48847);









// eslint-disable-next-line @typescript-eslint/no-var-requires
var showdown = __webpack_require__(53787);
var __N_SSP = true;
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(data) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
    var converter = new showdown.Converter();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pagelay__WEBPACK_IMPORTED_MODULE_4__/* .PageLayout */ .X, {
            crumb: [
                {
                    path: "/media/news/news_detail/".concat(data === null || data === void 0 ? void 0 : data.id),
                    name: data === null || data === void 0 ? void 0 : (ref = data.info) === null || ref === void 0 ? void 0 : ref.title
                }, 
            ],
            newsPath: (data === null || data === void 0 ? void 0 : data.category_id) === 3 ? "/media/industry" : "/media/news",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-4bc8492bac12aabc" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().container) || ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                                className: "jsx-4bc8492bac12aabc",
                                children: (data === null || data === void 0 ? void 0 : (ref1 = data.info) === null || ref1 === void 0 ? void 0 : ref1.meta_title) || (data === null || data === void 0 ? void 0 : (ref2 = data.info) === null || ref2 === void 0 ? void 0 : ref2.title)
                            }),
                            (data === null || data === void 0 ? void 0 : (ref3 = data.info) === null || ref3 === void 0 ? void 0 : ref3.desc) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "description",
                                content: data === null || data === void 0 ? void 0 : (ref4 = data.info) === null || ref4 === void 0 ? void 0 : ref4.desc,
                                className: "jsx-4bc8492bac12aabc"
                            }),
                            (data === null || data === void 0 ? void 0 : (ref5 = data.info) === null || ref5 === void 0 ? void 0 : ref5.meta_kws) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "keywords",
                                content: data === null || data === void 0 ? void 0 : (ref6 = data.info) === null || ref6 === void 0 ? void 0 : ref6.meta_kws,
                                className: "jsx-4bc8492bac12aabc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-4bc8492bac12aabc" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().left) || ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "jsx-4bc8492bac12aabc",
                                children: data === null || data === void 0 ? void 0 : (ref7 = data.info) === null || ref7 === void 0 ? void 0 : ref7.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "jsx-4bc8492bac12aabc" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().share) || ""),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "jsx-4bc8492bac12aabc",
                                        children: new Date(String(data === null || data === void 0 ? void 0 : data.publish_time).length === 10 ? (data === null || data === void 0 ? void 0 : data.publish_time) * 1000 : data === null || data === void 0 ? void 0 : data.publish_time).toLocaleString().replace(/\//g, "-").split(" ")[0]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "jsx-4bc8492bac12aabc",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_5__.CopyToClipboard, {
                                                text: "".concat(_utils__WEBPACK_IMPORTED_MODULE_8__/* .PRODFORNTDOMAIN */ .zE, "/media/news/news_detail/").concat(data === null || data === void 0 ? void 0 : data.id),
                                                onCopy: function() {
                                                    _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_6__/* .Notification.success */ .P_.success({
                                                        content: "复制成功！快去微信分享文章吧",
                                                        duration: 3
                                                    });
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "jsx-4bc8492bac12aabc" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().wx) || "")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                onClick: function() {
                                                    var ref;
                                                    return [
                                                        window.open("http://service.weibo.com/share/share.php?url=" + encodeURIComponent("".concat(_utils__WEBPACK_IMPORTED_MODULE_8__/* .PRODFORNTDOMAIN */ .zE, "/media/news/news_detail/").concat(data === null || data === void 0 ? void 0 : data.id)) + "?sharesource=weibo&title=" + (data === null || data === void 0 ? void 0 : (ref = data.info) === null || ref === void 0 ? void 0 : ref.title))
                                                    ];
                                                },
                                                className: "jsx-4bc8492bac12aabc" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().xinlang) || "")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: converter.makeHtml(data === null || data === void 0 ? void 0 : (ref8 = data.info) === null || ref8 === void 0 ? void 0 : ref8.content)
                                },
                                className: "jsx-4bc8492bac12aabc" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().content) || "")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "jsx-4bc8492bac12aabc" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().footer) || ""),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "jsx-4bc8492bac12aabc",
                                        children: [
                                            "上一篇：",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: (data === null || data === void 0 ? void 0 : (ref9 = data.prev_article) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.info) === null || ref10 === void 0 ? void 0 : ref10.outlink) ? data === null || data === void 0 ? void 0 : (ref11 = data.prev_article) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.info) === null || ref12 === void 0 ? void 0 : ref12.outlink : "/media/news/news_detail/".concat(data === null || data === void 0 ? void 0 : (ref13 = data.prev_article) === null || ref13 === void 0 ? void 0 : ref13.id),
                                                className: "jsx-4bc8492bac12aabc",
                                                children: data === null || data === void 0 ? void 0 : (ref14 = data.prev_article) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.info) === null || ref15 === void 0 ? void 0 : ref15.title
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "jsx-4bc8492bac12aabc",
                                        children: [
                                            "下一篇：",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: (data === null || data === void 0 ? void 0 : (ref16 = data.next_article) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.info) === null || ref17 === void 0 ? void 0 : ref17.outlink) ? data === null || data === void 0 ? void 0 : (ref18 = data.next_article) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.info) === null || ref19 === void 0 ? void 0 : ref19.outlink : "/media/news/news_detail/".concat(data === null || data === void 0 ? void 0 : (ref20 = data.next_article) === null || ref20 === void 0 ? void 0 : ref20.id),
                                                className: "jsx-4bc8492bac12aabc",
                                                children: data === null || data === void 0 ? void 0 : (ref21 = data.next_article) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.info) === null || ref22 === void 0 ? void 0 : ref22.title
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-4bc8492bac12aabc" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().right) || ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "jsx-4bc8492bac12aabc",
                                children: "更多新闻"
                            }),
                            data === null || data === void 0 ? void 0 : (ref23 = data.related_articles) === null || ref23 === void 0 ? void 0 : ref23.map(function(item) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: item.info.outlink ? "".concat(item.info.outlink) : "/media/news/news_detail/".concat(item.id),
                                    target: item.info.outlink ? "_blank" : "",
                                    className: "jsx-4bc8492bac12aabc",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "jsx-4bc8492bac12aabc" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().newItem) || ""),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: item.info.image,
                                                alt: "",
                                                className: "jsx-4bc8492bac12aabc"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "jsx-4bc8492bac12aabc",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        className: "jsx-4bc8492bac12aabc",
                                                        children: item.info.title
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "jsx-4bc8492bac12aabc",
                                                        children: item.info.brief
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "jsx-4bc8492bac12aabc",
                                                        children: new Date(String(item.publish_time).length === 10 ? item.publish_time * 1000 : item.publish_time).toLocaleString().replace(/\//g, "-").split(" ")[0]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: "/image/news-bg-btn.png",
                                                        alt: "",
                                                        className: "jsx-4bc8492bac12aabc" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().btn) || "")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, item.id);
                            })
                        ]
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                        id: "4bc8492bac12aabc",
                        children: ""
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 48847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sC": function() { return /* binding */ PRODDOMAIN; },
/* harmony export */   "zE": function() { return /* binding */ PRODFORNTDOMAIN; }
/* harmony export */ });
/* unused harmony exports DEVDOMAIN, getIsMobile, getIsSupportWebp */
var DEVDOMAIN = "http://localhost:3001";
// export const PRODDOMAIN = "http://system.icef.com.cn";
var PRODDOMAIN = "https://system.cbcechina.com";
// export const PRODDOMAIN = "http://cbce.smartinfo.cn";
var PRODFORNTDOMAIN = "https://www.cbcechina.com";
var getIsMobile = function(context) {
    var ref = context.ctx.req || {}, _headers = ref.headers, headers = _headers === void 0 ? {} : _headers;
    return /mobile|android|iphone|ipad|phone/i.test((headers["user-agent"] || "").toLowerCase());
};
var getIsSupportWebp = function(context) {
    var ref;
    var ref1 = context.ctx.req || {}, _headers = ref1.headers, headers = _headers === void 0 ? {} : _headers;
    return (ref = headers.accept) === null || ref === void 0 ? void 0 : ref.includes("image/webp");
};


/***/ }),

/***/ 81683:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__PYk2f","left":"styles_left__Ouj97","share":"styles_share__Kzs1y","wx":"styles_wx__6GNDK","xinlang":"styles_xinlang__lSR0L","footer":"styles_footer__n5MP8","right":"styles_right__Aagma","newItem":"styles_newItem__EVSQF","btn":"styles_btn__FKrh_"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3222,7043,5285,9774,2888,179], function() { return __webpack_exec__(14703); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);